var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"gov"},[_c('GovBannersView',{attrs:{"id":"gov","timestamp":_vm.timestamp}}),_c('SectionDigitalGovernment'),_c('SectionUseCase'),_c('SectionWhyXid'),_c('SectionClientGovVoice',{attrs:{"isGrayBackground":true}}),_c('SectionResource'),_c('SectionXidContact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }